import loginImage from './assets/img/login_image.jpg'

const CROP_MASTER_LOCALES = {
  pt: 'pt_br',
  es: 'es',
  en: 'en'
}

export const LOGIN_CROP_MASTER_CONFIG = {
  getHref: locale => {
    const baseUrl = 'https://cropmaster.academy/'
    const cropMasterLang = CROP_MASTER_LOCALES[locale] || CROP_MASTER_LOCALES.en
    return `${baseUrl}?lang=${cropMasterLang}`
  },
  imageSrc: loginImage,
  text1Key: 'decidePrecisely',
  text2Key: 'moveWithConfidence',
  text3Key: 'youAreACropMaster'
}
